/* eslint-disable react/prop-types */
/* globals window CustomEvent */
require('./src/utils/polyfills');

import React, { createElement } from 'react';
import { Transition } from 'react-transition-group';

require('gsap');
require('gsap/ScrollToPlugin');

import { animateIn, animateOut } from './src/utils/transitions';
import createHistory from 'history/createBrowserHistory';
import { paths, ids, modals } from './lookup.json';

import objectFitImages from 'object-fit-images';

import mitt from 'mitt';

const timeout = 0.4;
const historyExitingModalType = `history::modal`;
const historyExitingEventType = `history::exiting`;
const localeSwitchEventType = `locale::switch`;
const openModalEventType = `modal::open`;

const globalEmitter = mitt();
window.emitter = globalEmitter;

const getPathTransitionName = pathname => {
  let key = pathname.split('/');
  if (key.length > 1) {
    key.shift();
    key = key.join('/');
  } else {
    key = '/';
  }
  return key;
};

const transitionEnabler = (pathname, callback) => {
  let modalPathName = pathname;
  if (modalPathName.charAt(0) === '/') {
    modalPathName = modalPathName.substr(1);
  }
  const isModal = window.innerWidth > 767 && modals[modalPathName];
  const event = new CustomEvent(
    isModal ? historyExitingModalType : historyExitingEventType,
    {
      detail: { pathname }
    }
  );
  if (!isModal && window.currentPath === pathname) {
    return;
  }
  window.dispatchEvent(event);

  if (isModal) {
    return;
  }

  setTimeout(() => {
    callback(true);
  }, timeout * 1000);
};

const history = createHistory({ getUserConfirmation: transitionEnabler });
history.block((location, action) => location.pathname);
exports.replaceHistory = () => history;

class ReplaceComponentRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.hasAppeared = false;
    this.state = { exiting: false, nextPageResources: {} };
    this.currentLocale = props.locale;
    this.modalHandler = this.modalHandler.bind(this);
    this.listenerHandler = this.listenerHandler.bind(this);
    this.handleLocaleSwitch = this.handleLocaleSwitch.bind(this);

    if (typeof window !== 'undefined') {
      window.currentPath = this.props.location.pathname;
    }
  }

  componentDidMount() {
    window.addEventListener(historyExitingModalType, this.modalHandler);
    window.addEventListener(historyExitingEventType, this.listenerHandler);
    window.addEventListener(localeSwitchEventType, this.handleLocaleSwitch);
    setTimeout(() => {
      this.hasAppeared = true;
    }, 1);
  }

  componentWillUnmount() {
    window.removeEventListener(historyExitingModalType, this.modalHandler);
    window.removeEventListener(historyExitingEventType, this.listenerHandler);
    window.removeEventListener(localeSwitchEventType, this.handleLocaleSwitch);
  }

  listenerHandler(event) {
    // console.log(
    //   event.detail.pathname,
    //   this.props.location.pathname,
    //   event.detail.pathname === this.props.location.pathname
    // );
    if (event.detail.pathname === this.props.location.pathname) {
      return;
    }
    const nextPageResources =
      this.props.loader.getResourcesForPathname(
        event.detail.pathname,
        nextPageResources => this.setState({ nextPageResources })
      ) || {};

    this.setState({ exiting: true, nextPageResources });
  }

  modalHandler(event) {
    const nextPageResources =
      this.props.loader.getResourcesForPathname(event.detail.pathname) || {};

    const modalEvent = new CustomEvent(openModalEventType, {
      detail: {
        pathname: event.detail.pathname,
        data: nextPageResources.json.data.datoCmsPage
      }
    });
    window.dispatchEvent(modalEvent);
  }

  handleLocaleSwitch(event) {
    const { locale } = event.detail;

    // if (locale === this.currentLocale) {
    //   return;
    // }

    this.currentLocale = locale;
    let locationPathName = this.props.location.pathname;

    if (locationPathName.charAt(0) === '/') {
      locationPathName = locationPathName.substr(1);
    }

    const id = ids[locationPathName];
    let pathname = paths[id][locale];

    if (pathname === 'en/home' || pathname === '/') {
      pathname = '';
    }

    history.push(`/${pathname}`);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.key !== nextProps.location.key) {
      this.setState({ exiting: false, nextPageResources: {} });
    }
  }

  componentDidUpdate() {
    if (typeof window !== 'undefined') {
      window.currentPath = this.props.location.pathname;
    }
  }

  render() {
    const { location } = this.props;
    const transitionTimeout = {
      enter: this.hasAppeared ? timeout : 1,
      exit: 0
    };
    const transitionProps = {
      appear: true,
      in: !this.state.exiting,
      key: this.props.location.key,
      timeout: transitionTimeout,
      onEnter: (el, isAppearing) => {
        animateIn(el, this.hasAppeared === false, transitionTimeout.enter);
      },
      onExiting: el => {
        animateOut(el);
      }
    };
    return (
      <Transition {...transitionProps}>
        {status => {
          return createElement(this.props.pageResources.component, {
            ...this.props,
            ...this.props.pageResources.json
          });
        }}
      </Transition>
    );
  }
}

// eslint-disable-next-line react/display-name
exports.replaceComponentRenderer = ({ props, loader }) => {
  if (props.layout) {
    return undefined;
  }
  const locale = props.location.pathname.indexOf('fr/') > 0 ? 'fr' : 'en';
  return createElement(ReplaceComponentRenderer, { ...props, loader, locale });
};

exports.onInitialClientRender = () => {
  objectFitImages();
};



// WEBPACK FOOTER //
// ./gatsby-browser.js